import { FormikProps } from 'formik';
import React from 'react';
import {Attributes} from "../../modules/tp/builders/FormBuilder";

export type TitleProps<T> = {
    inputObj: TitleViewObj<T>
    formik: FormikProps<T>,
    entity: T,
}

export type TitleViewObj<T> = {
    [key: string]: any,
    type: "titleView",
    attributes?: Attributes,
    title: string | JSX.Element
    icon?: string | JSX.Element
    classes?: string
} & Attributes

export const TitleView = <T,>({inputObj} : TitleProps<T>) => {
    const {title, icon, attributes, classes} = inputObj
    const addClasses = `tp-form-title ${classes}`;
    return <div className={addClasses} {...attributes}>
        <h3 className='tp-form-title-text'>
            {icon && <span className='tp-form-title-icon'> {icon} </span>}&nbsp;
            {typeof title  === "string" ? title.toUpperCase() : title }
        </h3>
    </div>
}

export default TitleView
